<template>
  <div class="drop-zone-wrap">
    <Dropzone
      ref="layer"
      id="layer"
      :options="fileLoadOptions"
      :class="{grounded:contacts.layout}"
      :useCustomSlot="true"
      @vdropzone-success="successLay"
      :include-styling="false"
      :style="bg('layer')"
    >
      <div class="picture_control">
        <div class="change-pic">
          <SvgIcon name="camera" width="24px" height="24px" fill="#fff"></SvgIcon>
        </div>
        <div class="remove-pic" @click="$emit('unbind','layout')" @click.stop>
          <SvgIcon name="delete" width="24px" height="24px" fill="#fff"></SvgIcon>
        </div>
      </div>
      <div class="dropzone-custom-content">
        <div class="subtitle">Загрузить обложку</div>
      </div>
    </Dropzone>
    <Dropzone
      ref="avatar"
      id="avatar"
      :options="fileLoadOptions"
      :class="{grounded:contacts.avatar}"
      :useCustomSlot="true"
      @vdropzone-success="successAvatar"
      :include-styling="false"
      :style="bg('avatar')"
    >
      <div class="picture_control">
        <div class="change-pic">
          <SvgIcon name="camera" width="24px" height="24px" fill="#fff"></SvgIcon>
        </div>
        <div class="remove-pic" @click="$emit('unbind','avatar')" @click.stop>
          <SvgIcon name="delete" width="24px" height="24px" fill="#fff"></SvgIcon>
        </div>
      </div>
      <div class="dropzone-custom-content">
        <div class="subtitle">Загрузить аватарку</div>
      </div>
    </Dropzone>
  </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import { DropZoneBaseOptions } from "@/library/lib.js";

export default {
  name: "DropzoneProfile",
  components: {
    Dropzone: vue2Dropzone
  },
  props: ["contacts"],
  data() {
    return {
      fileLoadOptions: {
        ...new DropZoneBaseOptions(),
        maxFiles: 1
      }
    };
  },
  methods: {
    successLay: function(file, response) {
      this.contacts.layout = response.url;
      this.contacts.layout_id = response.id;
      this.$emit("bind", "layout");
      this.$refs.layer.removeAllFiles();
    },
    successAvatar: function(file, response) {
      this.contacts.avatar = response.url;
      this.contacts.avatar_id = response.id;
      this.$emit("bind", "avatar");
      this.$refs.avatar.removeAllFiles();
    },
    bg: function(type) {
      if (type === "layer" && this.contacts.layout) {
        return `background-image:url(${this.contacts.layout})`;
      }
      if (type === "avatar" && this.contacts.avatar) {
        return `background-image:url(${this.contacts.avatar})`;
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
#layer {
  position: relative;
  z-index: 1;
  cursor: pointer;
  .picture_control {
    position: absolute;
    top: 16px;
    right: 16px;
  }
}

#avatar {
  cursor: pointer;
  position: relative;
  z-index: 2;
}
.drop-zone-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 56px;
  .picture_control {
    display: none;
  }
  .grounded {
    border: 1px solid $calmColor !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    cursor: default !important;
    .dz-message {
      .subtitle {
        display: none;
      }
      .picture_control {
        display: none;
        color: #fff;
        .change-pic,
        .remove-pic {
          width: 40px;
          height: 40px;
          flex: 0 0 40px;
          border-radius: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        .change-pic {
          background: $mainColor;
          margin-right: 8px;
        }
        .remove-pic {
          background: #eb4b4b;
        }
      }
      &:hover {
        .picture_control {
          display: flex;
          z-index: 12;
        }
      }
    }
  }
  .dz-message {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .subtitle {
      text-align: center;
      color: $mainColor;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
    }
  }

  #layer {
    width: 100%;
    height: 247px;
    @include border();
    border-style: dashed;
  }
  #avatar {
    margin-top: -64px;
    width: 128px;
    height: 128px;
    @include border();
    border-radius: 128px !important;
    border-style: dashed;
    background: #fff;
  }
}
</style>
